/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from "react";

function Separater(props) {
  const { mode = "horizontal", thick = "1px", size } = props;
  let width, height;
  switch (mode) {
    case "vertical":
      width = thick;
      break;
    case "horizontal":
      height = thick;
      break;
  }
  return (
    <div
      style={{
        width,
        height,
        background: `#bebebe6e`,
        // padding: "2.6px 0",
        margin: "3px 2.6px",
      }}
    />
  );
}

export default Separater;
